
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advisory-team",
      function () {
        return require("private-next-pages/advisory-team.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advisory-team"])
      });
    }
  